/**
 * Created by Christof Sander on 27.09.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'checkbox'
			],
			core: {
				multiple:   true
			},
			checkbox: {
				three_state: false,
				// cascade: 'down+undetermined'
				// cascade: 'down'
				cascade: ''
			}
		}
	},

	methods: {
		prepare: function(){
			if(this.actualParentComponent){
				var selectionConfig = (this.actualParentComponent.model || {}).selectionConfig || {};
				if(selectionConfig.multiSelect) {
					if(selectionConfig.selectCascade !== undefined){
						this.config.treeConfig.checkbox.cascade = selectionConfig.selectCascade || '';
					}
				} else {
					const checkboxPluginIndex = this.config.treeConfig.plugins.indexOf('checkbox')
					if(checkboxPluginIndex > -1){
						this.config.treeConfig.plugins.splice(checkboxPluginIndex, 1);
					}
				}
			}
		}
	}
};
